import React from "react";
import { Star, Quote } from "lucide-react";
import { useSection } from "@/context/SiteContext";

function Stars({ n }) {
  const num = Number(n) || 0;
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={15}
          className={i <= num ? "fill-[var(--primary)] text-[var(--primary)]" : "text-stone-300"}
          strokeWidth={2}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  const r = useSection("reviews");
  const avg = Number(r.rating_value || 4.1);
  const count = r.rating_count || "300+";

  const reviews = [1, 2, 3]
    .map((i) => ({
      text: r[`review_${i}_text`],
      name: r[`review_${i}_name`],
      rating: r[`review_${i}_rating`] ?? 5,
    }))
    .filter((x) => x.text);

  return (
    <section id="recensioner" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 space-y-4">
          <span className="inline-block text-xs uppercase tracking-[0.22em] font-semibold text-[var(--primary)]">
            {r.eyebrow || "Gästernas röster"}
          </span>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-black tracking-tight">
            {r.title || "Vad våra gäster säger"}
          </h2>
          <div className="flex items-center justify-center gap-3 pt-2 flex-wrap">
            <Stars n={Math.round(avg)} />
            <span className="font-serif-display text-2xl font-bold">{avg.toFixed(1)} / 5</span>
            <span className="text-[var(--text-muted)] text-sm">· baserat på {count} recensioner</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((rev, i) => (
            <article
              key={rev.name + i}
              data-testid={`review-card-${i}`}
              className="relative bg-white border border-[var(--border)]/70 rounded-2xl p-7 shadow-sm hover:shadow-md transition-shadow"
            >
              <Quote className="absolute top-5 right-5 text-[var(--primary)]/15" size={44} strokeWidth={1.5} />
              <Stars n={rev.rating} />
              <p className="mt-4 text-[var(--text)] leading-relaxed text-[15px]">&ldquo;{rev.text}&rdquo;</p>
              <div className="mt-6 pt-5 border-t border-[var(--border)] flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-[var(--surface-alt)] grid place-items-center font-semibold text-sm text-[var(--text)]">
                  {(rev.name || "?").charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-semibold">{rev.name}</div>
                  <div className="text-xs text-[var(--text-muted)]">Gäst hos Mon Ami</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
